import { Button, Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './style.module.css';

const { Title, Paragraph, Text } = Typography;

interface Review {
  name: string;
  description: string;
  image: string;
}

const AboutReviews: React.FC = () => {
  const { t } = useTranslation();
  const reviews = t('reviews.items', { returnObjects: true }) as Review[];
  const [idx, setIdx] = useState(0);
  const prev = () => setIdx((i) => (i - 1 + reviews.length) % reviews.length);
  const next = () => setIdx((i) => (i + 1) % reviews.length);

  return (
    <div className={styles.outer}>
      <div className={styles.wrapper}>
        <section className={styles.about}>
          <div className={styles.aboutContent}>
            <div className={styles.textSection}>
              <Title level={2} className={styles.title}>
                {t('about.title')}
              </Title>
              <Paragraph className={styles.text}>{t('about.text')}</Paragraph>
            </div>
            <div className={styles.imageSection}>
              <img src="/aboutphoto.jpg" width={1280} height={960} loading="lazy" alt={t('about.title')} className={styles.aboutImage} />
            </div>
          </div>
        </section>

        <section className={styles.reviews}>
          <Title level={2} className={styles.reviewsTitle}>
            {t('reviews.title')}
          </Title>

          <div className={styles.slider}>
            <button type="button" aria-label="Previous review" className={styles.arrow} onClick={prev}>
              ‹
            </button>

            <div className={styles.card}>
              <img src={reviews[idx].image} loading="lazy" alt={reviews[idx].name} className={styles.avatar} />
              <Paragraph className={styles.desc}>{reviews[idx].description}</Paragraph>
              <Text strong className={styles.name}>
                {reviews[idx].name}
              </Text>
            </div>

            <button type="button" aria-label="Next review" className={styles.arrow} onClick={next}>
              ›
            </button>
          </div>

          <div className={styles.dots}>
            {reviews.map((_, i) => (
              <span key={i} className={`${styles.dot} ${i === idx ? styles.active : ''}`} onClick={() => setIdx(i)} />
            ))}
          </div>
        </section>
        <Button className={styles.button} type="primary" href="#routes">
          {t('reviews.button')}
        </Button>
      </div>
    </div>
  );
};

export default AboutReviews;
